import { render, staticRenderFns } from "./MailboxFooter.vue?vue&type=template&id=19a760d4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a760d4')) {
      api.createRecord('19a760d4', component.options)
    } else {
      api.reload('19a760d4', component.options)
    }
    module.hot.accept("./MailboxFooter.vue?vue&type=template&id=19a760d4&", function () {
      api.rerender('19a760d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/apps/mailbox/MailboxFooter.vue"
export default component.exports